import { Div, Base } from '@codesuma/baseline'
import handleService from '../../../services/handle'
import { toast } from '../../../utils/toast'
import style from './index.module.css'

// Optional public name, shown right under the sharing ID. Without it a friend
// sharing a list only ever sees a random code like "moon-light-456" — with it
// they see who that code belongs to, which is what makes picking the right
// person possible when several lists are shared around.
// Saves on blur or Enter; blank clears it back to the code-only state.
export const NameRow = () => {
    const base = Div()
    base.addClass(style.base)

    const label = Div('Your name (optional) — shown to people you share lists with')
    label.addClass(style.label)

    const input = Base('input') as any
    input.addClass(style.input)
    input.el.setAttribute('placeholder', 'e.g. Sara')
    input.el.setAttribute('type', 'text')
    input.el.setAttribute('maxlength', '40')
    input.el.setAttribute('autocorrect', 'off')

    base.append(label, input)

    // What the server last confirmed, so an unchanged blur costs no request.
    let saved = ''

    const save = async () => {
        const value = (input.el as HTMLInputElement).value.trim()
        if (value === saved) return
        try {
            const updated = await handleService.updateDisplayName(value || null)
            saved = updated.display_name || ''
            ;(input.el as HTMLInputElement).value = saved
            toast(saved ? 'Name saved' : 'Name cleared')
        } catch (err) {
            console.error('Failed to save the display name:', err)
            // The server rejects some names outright (see update-display-name),
            // so put the accepted one back rather than leaving a lie on screen.
            ;(input.el as HTMLInputElement).value = saved
            toast("Couldn't save that name")
        }
    }

    input.el.addEventListener('blur', save)
    input.el.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key === 'Enter') (input.el as HTMLInputElement).blur()
    })

    return Object.assign(base, {
        // Called by the page once the handle (and its display_name) is loaded.
        setName(name: string | null) {
            saved = name || ''
            if (document.activeElement !== input.el) (input.el as HTMLInputElement).value = saved
        },
    })
}
